import React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'
import { CustomIframe } from '../../../components/shared/customIframe/customIframe'
import { getActiveBalanceZone, getActiveCompany, getCustomerDomain } from '../../../redux'
import { Button } from '@material-ui/core'
import { NonAuthRoutes } from '../../../model'
import { useHistory } from 'react-router'
import { EnumClientTypes } from '../../../api/Argentia/enums/enumClientTypes'

export interface ProductDataPageProps {
  location: { state: { clientType: EnumClientTypes } }
}

export const ProductDataPage: React.FC<ProductDataPageProps> = props => {
  const apiSuffixUrl = 'https://' + getCustomerDomain()
  const history = useHistory()
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'clientsMod'])
  const clientType = props.location?.state?.clientType ?? EnumClientTypes.FINAL_CLIENT

  // const apiSuffixUrl = 'https://localhost:44394';
  let activeCompany = getActiveCompany()
  let activeBalanceZone = getActiveBalanceZone()
  const [routeLocal, setRouteLocal] = useState(`${apiSuffixUrl}/clientes/productdata`)

  useEffect(() => {
    call()
  }, [activeCompany, activeBalanceZone])

  const call = async () => {
    setRouteLocal(
      `${apiSuffixUrl}/company/index/${activeCompany?.id}?idBalanceZone=${activeBalanceZone?.id}&company=${activeCompany?.description}&balanceZoneDescription=${activeBalanceZone?.description}`
    )

    setTimeout(() => {
      setRouteLocal(`${apiSuffixUrl}/clientes/productdata`)
    }, 1000)
  }

  return (
    <Page>
      <PageHeader title={t('clientsMod:productData')}>
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={() => {
            history.push(NonAuthRoutes.Client)
          }}
        >
          {t('clientsMod:buttons.back')}
        </Button>
      </PageHeader>

      <CustomIframe
        route={decodeURI(routeLocal)}
        width="100%"
        height="1200"
        allowFullScreen={true}
      />
    </Page>
  )
}
